import { render, staticRenderFns } from "./LeaveRateBtn.vue?vue&type=template&id=ce8d243c&"
import script from "./LeaveRateBtn.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LeaveRateBtn.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce8d243c')) {
      api.createRecord('ce8d243c', component.options)
    } else {
      api.reload('ce8d243c', component.options)
    }
    module.hot.accept("./LeaveRateBtn.vue?vue&type=template&id=ce8d243c&", function () {
      api.rerender('ce8d243c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LeaveRateBtn.vue"
export default component.exports